/**
 * @author       denys.yefremov@startupsoft.co (Denys Yefremov)
 * @copyright    Copyright (c) 2022, Zumper
 */

export const SCHOOLS_PER_PAGE = 5

export const possibleLevels = ['elementary', 'middle', 'high'] as const
export const detailPossibleLevels = ['elementary', 'middle', 'high', 'private'] as const
